import { useAuth } from "../context/AuthContext";
import { AmbassadorLayout } from "./AmbassadorLayout";
import { PublicLayout } from "./PublicLayout";
import EventDetail from "../pages/EventDetail";
import PublicEvent from "../pages/PublicEvent";

/** /events/:slug — public crawlable landing page for guests, in-app detail for members. */
export const EventRoute = () => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  }
  if (user === false) {
    return <PublicLayout><PublicEvent /></PublicLayout>;
  }
  return (
    <AmbassadorLayout>
      <EventDetail />
    </AmbassadorLayout>
  );
};
